import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Observable, catchError, take } from 'rxjs';

import { UrlBuilder } from '@venecia/builders';
import { TemplateHelper } from '@venecia/apis/base';
import { ConfigService } from '@venecia/services';

@Injectable({ providedIn: 'root' })
export class SessionsApi {
    private readonly http = inject(HttpClient);
    private readonly configService = inject(ConfigService);

    private urlBuilder?: UrlBuilder;

    constructor() {
        this.configService
            .select('http.rest.auth.url')
            .pipe(take(1))
            .subscribe((value: string) => {
                this.urlBuilder = new UrlBuilder(value, '/api/sessions');
            });
    }

    logout(): Observable<void> {
        const url = this.urlBuilder!.build('/logout');

        return this.http
            .put<void>(url, null, {
                withCredentials: true,
            })
            .pipe(
                TemplateHelper.applyRetry(),
                catchError((err) => TemplateHelper.handleError(err))
            );
    }
}
